import React, { useState } from "react";
import "./App.css";
import { useLocation } from "react-router-dom";
import DrawerLeft from "./components/UI/DrawerLeft";
import { ThemeProvider } from "@mui/material/styles";
import { GlobalStyles } from "@mui/material";
import CssBaseline from "@mui/material/CssBaseline";
import { BackgroundApp } from "./styles/App.styled";
import ReportPopin from "./components/Popin/ReportPopin";
import Main from "./Main";
import { theme, STORAGE_KEY } from "./theme/theme";
import { cssVariables } from "./theme/tokens";

export default function App() {
  const [isReportPopinOpen, setIsReportPopinOpen] = useState(false);
  const location = useLocation();
  // Login and public previews pages keep their dark look whatever the user's preference
  const publicPage = ["previews", "login"].find((page) => location.pathname.includes(page));

  const handleReportPopinOpen = () => {
    setIsReportPopinOpen(true);
  };

  const handleReportPopinClose = () => {
    setIsReportPopinOpen(false);
  };

  return (
    <ThemeProvider theme={theme} defaultMode="dark" modeStorageKey={STORAGE_KEY} disableTransitionOnChange>
      <CssBaseline enableColorScheme />
      <GlobalStyles styles={cssVariables} />
      <BackgroundApp $publicPage={publicPage}>
        <DrawerLeft handleReportPopinOpen={handleReportPopinOpen} />
        <Main />
        <ReportPopin isReportPopinOpen={isReportPopinOpen} handleReportPopinClose={handleReportPopinClose} />
      </BackgroundApp>
    </ThemeProvider>
  );
}
